export default "__VITE_ASSET__CDNwgDv___"